import { Modal, Button } from "react-bootstrap"

export const SearchFiltersModal = ({ showModal, title, handleClose, handleConfirm, handleReset, disableConfirm = false, children }) => {
	return (
		<Modal show={ showModal } onHide={ handleClose } className="search-filters-modal tag-selector-scroll-container">
			<Modal.Header>
				<Modal.Title>{ title }</Modal.Title>
				<button type="button" className="close p-0 m-0" onClick={ handleClose }>
					<span aria-hidden="true">&times;</span>
				</button>
			</Modal.Header>
			<Modal.Body>{ children }</Modal.Body>
			<Modal.Footer>
				{handleClose && <Button size="sm" onClick={ handleClose } className="btn btn-secondary">Cancel</Button>}
				{handleReset && <Button size="sm" onClick={ handleReset } className="btn" variant="outline-secondary">Reset</Button>}
				<Button size="sm" onClick={ handleConfirm } disabled={ disableConfirm } className="btn btn-primary">Apply</Button>
			</Modal.Footer>
		</Modal>
	)
}